var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_1866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 17H28C28 18.8 27.5 20.5 26.6 22L28.1 23.5C29.3 21.5 29.9 19.3 30 17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 17V9.00001C25 5.10001 21.8 2.00001 17.9 2.10001C15 2.10001 12.3 4.00001 11.4 6.80001L24.4 19.8C24.8 18.9 25 17.9 25 17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 26.6001L32.1 33.5001L33.5 32.1001L3.99998 2.6001L2.59998 4.0001L11 12.4001V17.0001C11 20.9001 14.1 24.0001 18 24.0001C19.3 24.0001 20.5 23.7001 21.6 23.0001L23.8 25.2001C22.1 26.4001 20.1 27.0001 18 27.0001C12.6 27.2001 8.19998 22.9001 7.99998 17.6001V17.0001H5.99998C6.09998 23.2001 10.8 28.4001 17 29.0001V32.0001H14C13.4 32.0001 13 32.4001 13 33.0001C13 33.6001 13.4 34.0001 14 34.0001H22C22.6 34.0001 23 33.6001 23 33.0001C23 32.4001 22.6 32.0001 22 32.0001H19V29.0001C21.2 28.8001 23.4 28.0001 25.2 26.6001Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_1866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.d0df6dcdfe83fa65326148b539bdf078.svg";
export { ForwardRef as ReactComponent };